import Vue from 'vue'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})

Vue.filter('truncate', function (text, length) {
  if (text.length > length) {
    return text.substring(0, length) + '...'
  }
  return text
})

Vue.filter('startend', function (str) {
  if (str.length > 15) {
    return str.substr(0, 25) + '...' + str.substr(str.length - 10, str.length)
  }
  return str
})

Vue.filter('filebucket', function (str) {
  if (str.length > 15) {
    return str.substr(0, 15) + '...' + str.substr(str.length - 10, str.length)
  }
  return str
})
//File Size Converter
Vue.filter('fileSizeConverter', function (fileSizeInBytes) {
  var i = -1;
  var byteUnits = [' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
  do {
    fileSizeInBytes = fileSizeInBytes / 1024;
    i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
})

Vue.filter('formatBytes', function (bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
})
